module.exports = __webpack_public_path__ + "img/71.1a4d702d.jpg";